import keyBy from 'lodash-es/keyBy';
import { SalesAdminActionKeys as keys, SalesAdminActionTypes } from '.';
import { uniqObjectMerge, uniqPrimativeMerge } from '../../utils/arrayUtils';
import { ISalesDistrict } from '../lookups';
import { ISalesDistrictDealerGoal, SalesAdminLoadingTypes } from './salesAdminInterfaces';

export interface IAdminSalesState {
  districtHash: { [index: string]: ISalesDistrict };
  countyColorHash: { [index: string]: string };
  districtIds: string[];
  loading: SalesAdminLoadingTypes[];
  districtGoals: ISalesDistrictDealerGoal[];
}

const initialState: IAdminSalesState = {
  countyColorHash: {},
  districtGoals: [],
  districtHash: {},
  districtIds: [],
  loading: []
};

export function adminSalesReducer(
  state: IAdminSalesState = initialState,
  action: SalesAdminActionTypes
): IAdminSalesState {
  switch (action.type) {
    case keys.REMOVE_SALES_DISTRICT_GOAL:
      return {
        ...state,
        districtGoals: state.districtGoals.filter(
          x =>
            `${x.salesDistrict}_${x.businessEntityTypeId}_${x.fiscalYear}` !==
            `${action.payload.salesDistrict}_${action.payload.businessEntityTypeId}_${action.payload.fiscalYear}`
        )
      };
    case keys.SET_SA_SALES_DISTS:
      const countyColors = action.payload.reduce((arr, x) => {
        const counties = x.counties ? x.counties : [];
        return [...arr, ...counties.map(y => ({ countyFips: y.countyFipsId, color: x.color }))];
      }, []);
      return {
        ...state,
        countyColorHash: countyColors.reduce<{ [index: string]: string }>((hash, x) => {
          hash[x.countyFips] = x.color;
          return hash;
        }, {}),
        districtHash: keyBy(action.payload, (sd: ISalesDistrict) => sd.salesDistrictId),
        districtIds: uniqPrimativeMerge(state.districtIds, action.payload.map(x => x.salesDistrictId))
      };
    case keys.SET_SALES_DISTRICT_GOALS:
      return {
        ...state,
        districtGoals: uniqObjectMerge(
          state.districtGoals,
          action.payload,
          x => `${x.fiscalYear}_${x.salesDistrict}_${x.businessEntityTypeId}`
        )
      };
    case keys.TOGGLE_SA_LOADING:
      return {
        ...state,
        loading: state.loading.includes(action.payload)
          ? state.loading.filter(x => x !== action.payload)
          : [...state.loading, action.payload]
      };
    default:
      return state;
  }
}
